"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportEntityStatusToJSON = exports.AsyncReportEntityStatusFromJSONTyped = exports.AsyncReportEntityStatusFromJSON = exports.AsyncReportEntityStatus = void 0;
/**
 *
 * @export
 */
exports.AsyncReportEntityStatus = {
    Active: 'ACTIVE',
    Completed: 'COMPLETED',
    Stopped: 'STOPPED',
    Paused: 'PAUSED',
    PendingApproval: 'PENDING_APPROVAL',
    PendingAdvertiserApproval: 'PENDING_ADVERTISER_APPROVAL',
    Rejected: 'REJECTED'
};
function AsyncReportEntityStatusFromJSON(json) {
    return AsyncReportEntityStatusFromJSONTyped(json, false);
}
exports.AsyncReportEntityStatusFromJSON = AsyncReportEntityStatusFromJSON;
function AsyncReportEntityStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AsyncReportEntityStatusFromJSONTyped = AsyncReportEntityStatusFromJSONTyped;
function AsyncReportEntityStatusToJSON(value) {
    return value;
}
exports.AsyncReportEntityStatusToJSON = AsyncReportEntityStatusToJSON;
